import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vc-modal-facilipay-oney',
  templateUrl: './modal-facilipay-oney.component.html',
  styleUrls: ['./modal-facilipay-oney.component.scss']
})
export class ModalFacilipayOneyComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
